'use strict';

var phoneValidationModule = (function () {
    var countryPhonePatterns = {
        USA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: 'XXXXXXXXXX',
            description: 'US format: 10 digits'
        },
        CAN: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: 'XXXXXXXXXX',
            description: 'Canada format: 10 digits'
        },
        GBR: {
            countryCode: '+44',
            pattern: /^\+44\s?\d{10,11}$/,
            format: 'XXXXXXXXXX',
            description: 'UK format: 10-11 digits'
        },
        IRL: {
            countryCode: '+353',
            pattern: /^\+353\s?\d{9,10}$/,
            format: 'XXXXXXXXX',
            description: 'Ireland format: 9-10 digits'
        },
        IND: {
            countryCode: '+91',
            pattern: /^\+91\s?\d{10}$/,
            format: 'XXXXXXXXXX',
            description: 'India format: 10 digits'
        },
        AUS: {
            countryCode: '+61',
            pattern: /^\+61\s?\d{9,10}$/,
            format: 'XXXXXXXXX',
            description: 'Australia format: 9-10 digits'
        },
        DEU: {
            countryCode: '+49',
            pattern: /^\+49\s?\d{10,13}$/,
            format: 'XXXXXXXXXX',
            description: 'Germany format: 10-13 digits'
        },
        FRA: {
            countryCode: '+33',
            pattern: /^\+33\s?\d{9,10}$/,
            format: 'XXXXXXXXX',
            description: 'France format: 9-10 digits'
        },
        JPN: {
            countryCode: '+81',
            pattern: /^\+81\s?\d{10,11}$/,
            format: 'XXXXXXXXXX',
            description: 'Japan format: 10-11 digits'
        },
        CHN: {
            countryCode: '+86',
            pattern: /^\+86\s?\d{10,11}$/,
            format: 'XXXXXXXXXX',
            description: 'China format: 10-11 digits'
        },
        BRA: {
            countryCode: '+55',
            pattern: /^\+55\s?\d{10,11}$/,
            format: 'XXXXXXXXXX',
            description: 'Brazil format: 10-11 digits'
        },
        MEX: {
            countryCode: '+52',
            pattern: /^\+52\s?\d{10,11}$/,
            format: 'XXXXXXXXXX',
            description: 'Mexico format: 10-11 digits'
        },
        ESP: {
            countryCode: '+34',
            pattern: /^\+34\s?\d{9}$/,
            format: 'XXXXXXXXX',
            description: 'Spain format: 9 digits'
        },
        ITA: {
            countryCode: '+39',
            pattern: /^\+39\s?\d{10}$/,
            format: 'XXXXXXXXXX',
            description: 'Italy format: 10 digits'
        },
        ZAF: {
            countryCode: '+27',
            pattern: /^\+27\s?\d{9,10}$/,
            format: 'XXXXXXXXX',
            description: 'South Africa format: 9-10 digits'
        },
        NZL: {
            countryCode: '+64',
            pattern: /^\+64\s?\d{9,10}$/,
            format: 'XXXXXXXXX',
            description: 'New Zealand format: 9-10 digits'
        },
        AIA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        ASM: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        BHS: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        BLZ: {
            countryCode: '+501',
            pattern: /^\+501\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +501: 7 digits'
        },
        BMU: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        BRB: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        CYM: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        DMA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        DOM: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        GRD: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        GUM: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        JAM: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        KNA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        LCA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        MNP: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        MSR: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        PRI: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        TCA: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        TTO: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        VCT: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        VGB: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },
        VIR: {
            countryCode: '+1',
            pattern: /^\+1\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +1: 10 digits'
        },

        // ---- Europe (generated) ----
        ALA: {
            countryCode: '+358',
            pattern: /^\+358\s?\d{6,10}$/,
            format: '6-10 digits',
            description: 'Dial code +358: 6-10 digits'
        },
        ALB: {
            countryCode: '+355',
            pattern: /^\+355\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +355: 8-9 digits'
        },
        AND: {
            countryCode: '+376',
            pattern: /^\+376\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +376: 6 digits'
        },
        AUT: {
            countryCode: '+43',
            pattern: /^\+43\s?\d{10,11}$/,
            format: '10-11 digits',
            description: 'Dial code +43: 10-11 digits'
        },
        BEL: {
            countryCode: '+32',
            pattern: /^\+32\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +32: 8-9 digits'
        },
        BGR: {
            countryCode: '+359',
            pattern: /^\+359\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +359: 8-9 digits'
        },
        BIH: {
            countryCode: '+387',
            pattern: /^\+387\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +387: 8 digits'
        },
        BLR: {
            countryCode: '+375',
            pattern: /^\+375\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +375: 9 digits'
        },
        CHE: {
            countryCode: '+41',
            pattern: /^\+41\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +41: 9 digits'
        },
        CYP: {
            countryCode: '+357',
            pattern: /^\+357\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +357: 8 digits'
        },
        CZE: {
            countryCode: '+420',
            pattern: /^\+420\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +420: 9 digits'
        },
        DNK: {
            countryCode: '+45',
            pattern: /^\+45\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +45: 8 digits'
        },
        EST: {
            countryCode: '+372',
            pattern: /^\+372\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +372: 7-8 digits'
        },
        FIN: {
            countryCode: '+358',
            pattern: /^\+358\s?\d{6,10}$/,
            format: '6-10 digits',
            description: 'Dial code +358: 6-10 digits'
        },
        FRO: {
            countryCode: '+298',
            pattern: /^\+298\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +298: 6 digits'
        },
        GGY: {
            countryCode: '+44',
            pattern: /^\+44\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +44: 10 digits'
        },
        GIB: {
            countryCode: '+350',
            pattern: /^\+350\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +350: 8 digits'
        },
        GRC: {
            countryCode: '+30',
            pattern: /^\+30\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +30: 10 digits'
        },
        GRL: {
            countryCode: '+299',
            pattern: /^\+299\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +299: 6 digits'
        },
        HRV: {
            countryCode: '+385',
            pattern: /^\+385\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +385: 8-9 digits'
        },
        HUN: {
            countryCode: '+36',
            pattern: /^\+36\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +36: 9 digits'
        },
        IMN: {
            countryCode: '+44',
            pattern: /^\+44\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +44: 10 digits'
        },
        ISL: {
            countryCode: '+354',
            pattern: /^\+354\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +354: 7 digits'
        },
        JEY: {
            countryCode: '+44',
            pattern: /^\+44\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +44: 10 digits'
        },
        LIE: {
            countryCode: '+423',
            pattern: /^\+423\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +423: 7 digits'
        },
        LTU: {
            countryCode: '+370',
            pattern: /^\+370\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +370: 8 digits'
        },
        LUX: {
            countryCode: '+352',
            pattern: /^\+352\s?\d{6,9}$/,
            format: '6-9 digits',
            description: 'Dial code +352: 6-9 digits'
        },
        LVA: {
            countryCode: '+371',
            pattern: /^\+371\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +371: 8 digits'
        },
        MCO: {
            countryCode: '+377',
            pattern: /^\+377\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +377: 8-9 digits'
        },
        MDA: {
            countryCode: '+373',
            pattern: /^\+373\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +373: 8 digits'
        },
        MKD: {
            countryCode: '+389',
            pattern: /^\+389\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +389: 8 digits'
        },
        MLT: {
            countryCode: '+356',
            pattern: /^\+356\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +356: 8 digits'
        },
        MNE: {
            countryCode: '+382',
            pattern: /^\+382\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +382: 8 digits'
        },
        NLD: {
            countryCode: '+31',
            pattern: /^\+31\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +31: 9 digits'
        },
        NOR: {
            countryCode: '+47',
            pattern: /^\+47\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +47: 8 digits'
        },
        POL: {
            countryCode: '+48',
            pattern: /^\+48\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +48: 9 digits'
        },
        PRT: {
            countryCode: '+351',
            pattern: /^\+351\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +351: 9 digits'
        },
        ROU: {
            countryCode: '+40',
            pattern: /^\+40\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +40: 9 digits'
        },
        RUS: {
            countryCode: '+7',
            pattern: /^\+7\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +7: 10 digits'
        },
        SMR: {
            countryCode: '+378',
            pattern: /^\+378\s?\d{6,10}$/,
            format: '6-10 digits',
            description: 'Dial code +378: 6-10 digits'
        },
        SRB: {
            countryCode: '+381',
            pattern: /^\+381\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +381: 8-9 digits'
        },
        SVK: {
            countryCode: '+421',
            pattern: /^\+421\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +421: 9 digits'
        },
        SVN: {
            countryCode: '+386',
            pattern: /^\+386\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +386: 8 digits'
        },
        SWE: {
            countryCode: '+46',
            pattern: /^\+46\s?\d{7,9}$/,
            format: '7-9 digits',
            description: 'Dial code +46: 7-9 digits'
        },
        UKR: {
            countryCode: '+380',
            pattern: /^\+380\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +380: 9 digits'
        },
        VAT: {
            countryCode: '+379',
            pattern: /^\+379\s?\d{6,10}$/,
            format: '6-10 digits',
            description: 'Dial code +379: 6-10 digits'
        },
        ARE: {
            countryCode: '+971',
            pattern: /^\+971\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +971: 8-9 digits'
        },
        BHR: {
            countryCode: '+973',
            pattern: /^\+973\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +973: 8 digits'
        },
        IRQ: {
            countryCode: '+964',
            pattern: /^\+964\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +964: 9-10 digits'
        },
        ISR: {
            countryCode: '+972',
            pattern: /^\+972\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +972: 8-9 digits'
        },
        JOR: {
            countryCode: '+962',
            pattern: /^\+962\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +962: 8-9 digits'
        },
        KWT: {
            countryCode: '+965',
            pattern: /^\+965\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +965: 7-8 digits'
        },
        LBN: {
            countryCode: '+961',
            pattern: /^\+961\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +961: 7-8 digits'
        },
        OMN: {
            countryCode: '+968',
            pattern: /^\+968\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +968: 7-8 digits'
        },
        QAT: {
            countryCode: '+974',
            pattern: /^\+974\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +974: 7-8 digits'
        },
        SAU: {
            countryCode: '+966',
            pattern: /^\+966\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +966: 8-9 digits'
        },
        SYR: {
            countryCode: '+963',
            pattern: /^\+963\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +963: 8-9 digits'
        },
        TUR: {
            countryCode: '+90',
            pattern: /^\+90\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +90: 10 digits'
        },
        YEM: {
            countryCode: '+967',
            pattern: /^\+967\s?\d{7,9}$/,
            format: '7-9 digits',
            description: 'Dial code +967: 7-9 digits'
        },
        AGO: {
            countryCode: '+244',
            pattern: /^\+244\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +244: 9 digits'
        },
        BDI: {
            countryCode: '+257',
            pattern: /^\+257\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +257: 8 digits'
        },
        BEN: {
            countryCode: '+229',
            pattern: /^\+229\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +229: 8 digits'
        },
        BFA: {
            countryCode: '+226',
            pattern: /^\+226\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +226: 8 digits'
        },
        BWA: {
            countryCode: '+267',
            pattern: /^\+267\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +267: 7-8 digits'
        },
        CAF: {
            countryCode: '+236',
            pattern: /^\+236\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +236: 8 digits'
        },
        CIV: {
            countryCode: '+225',
            pattern: /^\+225\s?\d{8,10}$/,
            format: '8-10 digits',
            description: 'Dial code +225: 8-10 digits'
        },
        CMR: {
            countryCode: '+237',
            pattern: /^\+237\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +237: 8-9 digits'
        },
        COD: {
            countryCode: '+243',
            pattern: /^\+243\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +243: 9 digits'
        },
        COG: {
            countryCode: '+242',
            pattern: /^\+242\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +242: 9 digits'
        },
        COM: {
            countryCode: '+269',
            pattern: /^\+269\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +269: 7 digits'
        },
        CPV: {
            countryCode: '+238',
            pattern: /^\+238\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +238: 7 digits'
        },
        DJI: {
            countryCode: '+253',
            pattern: /^\+253\s?\d{6,8}$/,
            format: '6-8 digits',
            description: 'Dial code +253: 6-8 digits'
        },
        DZA: {
            countryCode: '+213',
            pattern: /^\+213\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +213: 8-9 digits'
        },
        EGY: {
            countryCode: '+20',
            pattern: /^\+20\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +20: 9-10 digits'
        },
        ERI: {
            countryCode: '+291',
            pattern: /^\+291\s?\d{6,7}$/,
            format: '6-7 digits',
            description: 'Dial code +291: 6-7 digits'
        },
        ESH: {
            countryCode: '+212',
            pattern: /^\+212\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +212: 9 digits'
        },
        ETH: {
            countryCode: '+251',
            pattern: /^\+251\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +251: 9 digits'
        },
        GAB: {
            countryCode: '+241',
            pattern: /^\+241\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +241: 7-8 digits'
        },
        GHA: {
            countryCode: '+233',
            pattern: /^\+233\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +233: 9 digits'
        },
        GIN: {
            countryCode: '+224',
            pattern: /^\+224\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +224: 8-9 digits'
        },
        GMB: {
            countryCode: '+220',
            pattern: /^\+220\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +220: 7 digits'
        },
        GNB: {
            countryCode: '+245',
            pattern: /^\+245\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +245: 7 digits'
        },
        GNQ: {
            countryCode: '+240',
            pattern: /^\+240\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +240: 9 digits'
        },
        KEN: {
            countryCode: '+254',
            pattern: /^\+254\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +254: 9 digits'
        },
        LBR: {
            countryCode: '+231',
            pattern: /^\+231\s?\d{7,9}$/,
            format: '7-9 digits',
            description: 'Dial code +231: 7-9 digits'
        },
        LBY: {
            countryCode: '+218',
            pattern: /^\+218\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +218: 8-9 digits'
        },
        LSO: {
            countryCode: '+266',
            pattern: /^\+266\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +266: 8 digits'
        },
        MAR: {
            countryCode: '+212',
            pattern: /^\+212\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +212: 9 digits'
        },
        MDG: {
            countryCode: '+261',
            pattern: /^\+261\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +261: 9 digits'
        },
        MLI: {
            countryCode: '+223',
            pattern: /^\+223\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +223: 8 digits'
        },
        MOZ: {
            countryCode: '+258',
            pattern: /^\+258\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +258: 9 digits'
        },
        MRT: {
            countryCode: '+222',
            pattern: /^\+222\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +222: 7-8 digits'
        },
        MUS: {
            countryCode: '+230',
            pattern: /^\+230\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +230: 7-8 digits'
        },
        MWI: {
            countryCode: '+265',
            pattern: /^\+265\s?\d{7,9}$/,
            format: '7-9 digits',
            description: 'Dial code +265: 7-9 digits'
        },
        MYT: {
            countryCode: '+262',
            pattern: /^\+262\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +262: 9 digits'
        },
        NAM: {
            countryCode: '+264',
            pattern: /^\+264\s?\d{7,9}$/,
            format: '7-9 digits',
            description: 'Dial code +264: 7-9 digits'
        },
        NER: {
            countryCode: '+227',
            pattern: /^\+227\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +227: 8 digits'
        },
        NGA: {
            countryCode: '+234',
            pattern: /^\+234\s?\d{7,10}$/,
            format: '7-10 digits',
            description: 'Dial code +234: 7-10 digits'
        },
        REU: {
            countryCode: '+262',
            pattern: /^\+262\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +262: 9 digits'
        },
        RWA: {
            countryCode: '+250',
            pattern: /^\+250\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +250: 9 digits'
        },
        SDN: {
            countryCode: '+249',
            pattern: /^\+249\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +249: 9 digits'
        },
        SEN: {
            countryCode: '+221',
            pattern: /^\+221\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +221: 9 digits'
        },
        SHN: {
            countryCode: '+290',
            pattern: /^\+290\s?\d{4}$/,
            format: '4 digits',
            description: 'Dial code +290: 4 digits'
        },
        SLE: {
            countryCode: '+232',
            pattern: /^\+232\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +232: 8 digits'
        },
        SOM: {
            countryCode: '+252',
            pattern: /^\+252\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +252: 7-8 digits'
        },
        SSD: {
            countryCode: '+211',
            pattern: /^\+211\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +211: 9 digits'
        },
        STP: {
            countryCode: '+239',
            pattern: /^\+239\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +239: 7 digits'
        },
        SWZ: {
            countryCode: '+268',
            pattern: /^\+268\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +268: 7-8 digits'
        },
        SYC: {
            countryCode: '+248',
            pattern: /^\+248\s?\d{6,7}$/,
            format: '6-7 digits',
            description: 'Dial code +248: 6-7 digits'
        },
        TCD: {
            countryCode: '+235',
            pattern: /^\+235\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +235: 8 digits'
        },
        TGO: {
            countryCode: '+228',
            pattern: /^\+228\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +228: 8 digits'
        },
        TUN: {
            countryCode: '+216',
            pattern: /^\+216\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +216: 8 digits'
        },
        TZA: {
            countryCode: '+255',
            pattern: /^\+255\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +255: 9 digits'
        },
        UGA: {
            countryCode: '+256',
            pattern: /^\+256\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +256: 9 digits'
        },
        ZMB: {
            countryCode: '+260',
            pattern: /^\+260\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +260: 9 digits'
        },
        ZWE: {
            countryCode: '+263',
            pattern: /^\+263\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +263: 9-10 digits'
        },

        // ---- Asia (generated) ----
        AFG: {
            countryCode: '+93',
            pattern: /^\+93\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +93 or 93 with 9 digits or just 9 digits'
        },
        ARM: {
            countryCode: '+374',
            pattern: /^\+374\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +374: 8 digits'
        },
        AZE: {
            countryCode: '+994',
            pattern: /^\+994\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +994: 9 digits'
        },
        BGD: {
            countryCode: '+880',
            pattern: /^\+880\s?\d{8,10}$/,
            format: '8-10 digits',
            description: 'Dial code +880: 8-10 digits'
        },
        BRN: {
            countryCode: '+673',
            pattern: /^\+673\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +673: 7 digits'
        },
        BTN: {
            countryCode: '+975',
            pattern: /^\+975\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +975: 7-8 digits'
        },
        GEO: {
            countryCode: '+995',
            pattern: /^\+995\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +995: 9 digits'
        },
        HKG: {
            countryCode: '+852',
            pattern: /^\+852\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +852: 8 digits'
        },
        IDN: {
            countryCode: '+62',
            pattern: /^\+62\s?\d{9,11}$/,
            format: '9-11 digits',
            description: 'Dial code +62: 9-11 digits'
        },
        KAZ: {
            countryCode: '+7',
            pattern: /^\+7\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +7: 10 digits'
        },
        KGZ: {
            countryCode: '+996',
            pattern: /^\+996\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +996: 9 digits'
        },
        KHM: {
            countryCode: '+855',
            pattern: /^\+855\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +855: 8-9 digits'
        },
        KOR: {
            countryCode: '+82',
            pattern: /^\+82\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +82: 9-10 digits'
        },
        LAO: {
            countryCode: '+856',
            pattern: /^\+856\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +856: 8-9 digits'
        },
        LKA: {
            countryCode: '+94',
            pattern: /^\+94\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +94: 9 digits'
        },
        MAC: {
            countryCode: '+853',
            pattern: /^\+853\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +853: 8 digits'
        },
        MDV: {
            countryCode: '+960',
            pattern: /^\+960\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +960: 7 digits'
        },
        MMR: {
            countryCode: '+95',
            pattern: /^\+95\s?\d{7,10}$/,
            format: '7-10 digits',
            description: 'Dial code +95: 7-10 digits'
        },
        MNG: {
            countryCode: '+976',
            pattern: /^\+976\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +976: 8 digits'
        },
        MYS: {
            countryCode: '+60',
            pattern: /^\+60\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +60: 9-10 digits'
        },
        NPL: {
            countryCode: '+977',
            pattern: /^\+977\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +977: 9-10 digits'
        },
        PAK: {
            countryCode: '+92',
            pattern: /^\+92\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +92: 9-10 digits'
        },
        PHL: {
            countryCode: '+63',
            pattern: /^\+63\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +63: 10 digits'
        },
        PRK: {
            countryCode: '+850',
            pattern: /^\+850\s?\d{8,10}$/,
            format: '8-10 digits',
            description: 'Dial code +850: 8-10 digits'
        },
        SGP: {
            countryCode: '+65',
            pattern: /^\+65\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +65: 8 digits'
        },
        THA: {
            countryCode: '+66',
            pattern: /^\+66\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +66: 9 digits'
        },
        TJK: {
            countryCode: '+992',
            pattern: /^\+992\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +992: 9 digits'
        },
        TKM: {
            countryCode: '+993',
            pattern: /^\+993\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +993: 8 digits'
        },
        TLS: {
            countryCode: '+670',
            pattern: /^\+670\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +670: 7-8 digits'
        },
        TWN: {
            countryCode: '+886',
            pattern: /^\+886\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +886: 8-9 digits'
        },
        UZB: {
            countryCode: '+998',
            pattern: /^\+998\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +998: 9 digits'
        },
        VNM: {
            countryCode: '+84',
            pattern: /^\+84\s?\d{9,10}$/,
            format: '9-10 digits',
            description: 'Dial code +84: 9-10 digits'
        },
        CCK: {
            countryCode: '+61',
            pattern: /^\+61\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +61: 9 digits'
        },
        COK: {
            countryCode: '+682',
            pattern: /^\+682\s?\d{5}$/,
            format: '5 digits',
            description: 'Dial code +682: 5 digits'
        },
        CXR: {
            countryCode: '+61',
            pattern: /^\+61\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +61: 9 digits'
        },
        FJI: {
            countryCode: '+679',
            pattern: /^\+679\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +679: 7 digits'
        },
        FSM: {
            countryCode: '+691',
            pattern: /^\+691\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +691: 7 digits'
        },
        KIR: {
            countryCode: '+686',
            pattern: /^\+686\s?\d{5}$/,
            format: '5 digits',
            description: 'Dial code +686: 5 digits'
        },
        MHL: {
            countryCode: '+692',
            pattern: /^\+692\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +692: 7 digits'
        },
        NCL: {
            countryCode: '+687',
            pattern: /^\+687\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +687: 6 digits'
        },
        NFK: {
            countryCode: '+672',
            pattern: /^\+672\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +672: 6 digits'
        },
        NIU: {
            countryCode: '+683',
            pattern: /^\+683\s?\d{4}$/,
            format: '4 digits',
            description: 'Dial code +683: 4 digits'
        },
        NRU: {
            countryCode: '+674',
            pattern: /^\+674\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +674: 7 digits'
        },
        PCN: {
            countryCode: '+64',
            pattern: /^\+64\s?\d{6,10}$/,
            format: '6-10 digits',
            description: 'Dial code +64: 6-10 digits'
        },
        PLW: {
            countryCode: '+680',
            pattern: /^\+680\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +680: 7 digits'
        },
        PNG: {
            countryCode: '+675',
            pattern: /^\+675\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +675: 7-8 digits'
        },
        PYF: {
            countryCode: '+689',
            pattern: /^\+689\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +689: 6 digits'
        },
        SLB: {
            countryCode: '+677',
            pattern: /^\+677\s?\d{5,7}$/,
            format: '5-7 digits',
            description: 'Dial code +677: 5-7 digits'
        },
        TKL: {
            countryCode: '+690',
            pattern: /^\+690\s?\d{4}$/,
            format: '4 digits',
            description: 'Dial code +690: 4 digits'
        },
        TON: {
            countryCode: '+676',
            pattern: /^\+676\s?\d{5,7}$/,
            format: '5-7 digits',
            description: 'Dial code +676: 5-7 digits'
        },
        TUV: {
            countryCode: '+688',
            pattern: /^\+688\s?\d{5,6}$/,
            format: '5-6 digits',
            description: 'Dial code +688: 5-6 digits'
        },
        VUT: {
            countryCode: '+678',
            pattern: /^\+678\s?\d{5,7}$/,
            format: '5-7 digits',
            description: 'Dial code +678: 5-7 digits'
        },
        WLF: {
            countryCode: '+681',
            pattern: /^\+681\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +681: 6 digits'
        },
        WSM: {
            countryCode: '+685',
            pattern: /^\+685\s?\d{5,7}$/,
            format: '5-7 digits',
            description: 'Dial code +685: 5-7 digits'
        },
        ARG: {
            countryCode: '+54',
            pattern: /^\+54\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +54: 10 digits'
        },
        BOL: {
            countryCode: '+591',
            pattern: /^\+591\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +591: 8 digits'
        },
        CHL: {
            countryCode: '+56',
            pattern: /^\+56\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +56: 9 digits'
        },
        COL: {
            countryCode: '+57',
            pattern: /^\+57\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +57: 10 digits'
        },
        CRI: {
            countryCode: '+506',
            pattern: /^\+506\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +506: 8 digits'
        },
        ECU: {
            countryCode: '+593',
            pattern: /^\+593\s?\d{8,9}$/,
            format: '8-9 digits',
            description: 'Dial code +593: 8-9 digits'
        },
        GTM: {
            countryCode: '+502',
            pattern: /^\+502\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +502: 8 digits'
        },
        GUY: {
            countryCode: '+592',
            pattern: /^\+592\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +592: 7 digits'
        },
        HND: {
            countryCode: '+504',
            pattern: /^\+504\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +504: 8 digits'
        },
        HTI: {
            countryCode: '+509',
            pattern: /^\+509\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +509: 8 digits'
        },
        NIC: {
            countryCode: '+505',
            pattern: /^\+505\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +505: 8 digits'
        },
        PAN: {
            countryCode: '+507',
            pattern: /^\+507\s?\d{7,8}$/,
            format: '7-8 digits',
            description: 'Dial code +507: 7-8 digits'
        },
        PER: {
            countryCode: '+51',
            pattern: /^\+51\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +51: 9 digits'
        },
        PRY: {
            countryCode: '+595',
            pattern: /^\+595\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +595: 9 digits'
        },
        SLV: {
            countryCode: '+503',
            pattern: /^\+503\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +503: 8 digits'
        },
        SUR: {
            countryCode: '+597',
            pattern: /^\+597\s?\d{6,7}$/,
            format: '6-7 digits',
            description: 'Dial code +597: 6-7 digits'
        },
        URY: {
            countryCode: '+598',
            pattern: /^\+598\s?\d{8}$/,
            format: '8 digits',
            description: 'Dial code +598: 8 digits'
        },
        VEN: {
            countryCode: '+58',
            pattern: /^\+58\s?\d{10}$/,
            format: '10 digits',
            description: 'Dial code +58: 10 digits'
        },
        ABW: {
            countryCode: '+297',
            pattern: /^\+297\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +297: 7 digits'
        },
        ANT: {
            countryCode: '+599',
            pattern: /^\+599\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +599: 7 digits'
        },
        BLM: {
            countryCode: '+590',
            pattern: /^\+590\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +590: 9 digits'
        },
        GLP: {
            countryCode: '+590',
            pattern: /^\+590\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +590: 9 digits'
        },
        GUF: {
            countryCode: '+594',
            pattern: /^\+594\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +594: 9 digits'
        },
        IOT: {
            countryCode: '+246',
            pattern: /^\+246\s?\d{7}$/,
            format: '7 digits',
            description: 'Dial code +246: 7 digits'
        },
        MAF: {
            countryCode: '+590',
            pattern: /^\+590\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +590: 9 digits'
        },
        MTQ: {
            countryCode: '+596',
            pattern: /^\+596\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +596: 9 digits'
        },
        SPM: {
            countryCode: '+508',
            pattern: /^\+508\s?\d{6}$/,
            format: '6 digits',
            description: 'Dial code +508: 6 digits'
        },
        ATF: {
            countryCode: '+262',
            pattern: /^\+262\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +262: 9 digits'
        },
        BVT: {
            countryCode: '+47',
            pattern: /^\+47\s?\d{7,10}$/,
            format: '7-10 digits',
            description: 'Dial code +47: 7-10 digits'
        },
        FLK: {
            countryCode: '+500',
            pattern: /^\+500\s?\d{5}$/,
            format: '5 digits',
            description: 'Dial code +500: 5 digits'
        },
        HMD: {
            countryCode: '+61',
            pattern: /^\+61\s?\d{9}$/,
            format: '9 digits',
            description: 'Dial code +61: 9 digits'
        },
        SGS: {
            countryCode: '+500',
            pattern: /^\+500\s?\d{5}$/,
            format: '5 digits',
            description: 'Dial code +500: 5 digits'
        }
    };
    var defaultPattern = {
        countryCode: '+1',
        pattern: /^[0-9\s+-]+$/,
        format: 'International format',
        description: 'International format: 6-15 digits'
    };

    function getPhonePattern(countryCode) {
        return countryPhonePatterns[countryCode] || defaultPattern;
    }

    function getCountryCode(countryCode) {
        var pattern = getPhonePattern(countryCode);
        return pattern.countryCode;
    }

    function validatePhoneNumber(phoneNumber, countryCode) {
        var result = {
            valid: false,
            message: '',
            pattern: null
        };
        if (!phoneNumber || phoneNumber.trim() === '') {
            result.message = 'Please enter a phone number.';
            return result;
        }
        var pattern = getPhonePattern(countryCode);
        result.pattern = pattern;
        var trimmedPhone = phoneNumber.trim();

        // Remove country code and spaces to get just the digits
        var phoneDigitsOnly = trimmedPhone.replace(/[\s\-+]/g, '');

        // If the phone number starts with country code digits, remove them
        var countryCodeDigits = pattern.countryCode.replace(/\+/g, '');
        if (phoneDigitsOnly.startsWith(countryCodeDigits)) {
            phoneDigitsOnly = phoneDigitsOnly.substring(countryCodeDigits.length);
        }

        // Test only the digits against the pattern
        if (!pattern.pattern.test(phoneDigitsOnly)) {
            result.message = 'Invalid phone number format for ' + countryCode + '. Expected: ' + pattern.description;
            return result;
        }
        result.valid = true;
        result.message = 'Valid phone number';
        return result;
    }
    function updateCountryCode(phoneInput, countryCode) {
        var code = getCountryCode(countryCode);
        phoneInput.data('country-code', code);
        phoneInput.attr('data-country-code', code);
    }

    function getFormatHelpText(countryCode) {
        var pattern = getPhonePattern(countryCode);
        return 'Format: ' + pattern.description + ' (Country code: ' + pattern.countryCode + ')';
    }
    return {
        validatePhoneNumber: validatePhoneNumber,
        getCountryCode: getCountryCode,
        getPhonePattern: getPhonePattern,
        updateCountryCode: updateCountryCode,
        getFormatHelpText: getFormatHelpText,
        countryPhonePatterns: countryPhonePatterns
    };
}());

module.exports = phoneValidationModule;
